








import { Component, Prop, Vue } from 'vue-property-decorator';

enum HEADING_TYPE {
  H1 = 1,
  H2 = 2,
}

@Component({
  name: 'header-component',
})
export default class HeaderComponent extends Vue {
  @Prop({ type: String, required: true }) text!: string;
  @Prop({ type: Number, default: 1 }) size!: number;

  private get headingClass(): Record<HEADING_TYPE, string> {
    return {
      [HEADING_TYPE.H1]: `heading-1`,
      [HEADING_TYPE.H2]: `leading-6 text-lg`,
    };
  }

  private get headingTag(): Record<HEADING_TYPE, 'h1' | 'h2'> {
    return { [HEADING_TYPE.H1]: 'h1', [HEADING_TYPE.H2]: 'h2' };
  }

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
